import Model from "../Model";

class Companymessage extends Model{

    buildUrl ({ param }) {
        return ['internalmessage/getmessagebycompany', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Companymessage;